export function tableOfContents(publication) {
    const convert = (links) => links.map((l) => ({ title: l.title ?? "", href: l.href, children: convert(l.children?.items ?? []) }));
    return convert((publication.toc?.items ?? []));
}
/** Titre de la section qui contient `href` : l'entrée la plus profonde qui pointe vers la même ressource. */
export function sectionTitle(toc, href) {
    if (!href)
        return undefined;
    const base = (h) => h.split("#")[0];
    let found;
    const visit = (entries) => {
        for (const e of entries) {
            if (found === undefined && base(e.href) === base(href) && e.title)
                found = e.title;
            visit(e.children);
        }
    };
    visit(toc);
    return found;
}
/**
 * Nom de section de chaque fichier de l'ordre de lecture : la dernière entrée de la table des
 * matières qui commence à ce fichier ou avant lui. undefined avant la première entrée.
 */
export function sectionLabeler(publication, toc) {
    const files = publication.readingOrder.items;
    const base = (href) => href.split("#")[0];
    const starts = [];
    const visit = (entries) => {
        for (const entry of entries) {
            const index = files.findIndex((file) => base(file.href) === base(entry.href));
            if (index >= 0 && entry.title)
                starts.push({ index, title: entry.title });
            visit(entry.children);
        }
    };
    visit(toc);
    starts.sort((a, b) => a.index - b.index);
    return (_href, index) => {
        let title;
        for (const start of starts) {
            if (start.index > index)
                break;
            title = start.title;
        }
        return title;
    };
}
//# sourceMappingURL=toc.js.map